angular.module('callX').controller('CreateSupportPageCtrl', ['$scope', '$state', 'UserService', '$rootScope', 'toaster', '$timeout', '$stateParams',function($scope, $state, UserService, $rootScope,toaster, $timeout,$stateParams) {
    
    $scope.ticket = {}
    $scope.ticket.id = 0;
    $scope.priorityOptions = ['Low', 'Medium', 'High', 'Urgency']
    $scope.categoryOptions = ['Financial', 'Technical' , 'Other']
    $scope.statusOptions = [
        'To Do',
        'In Progress',
        'Done',
    ];

    $scope.ticket = {
        status: 'To Do'  // Default status
    };

    // console.log($rootScope.userId, "from create support")

    $scope.setAgentFirsAandLastName = function() {
        $scope.firstName = window.localStorage.getItem("first_name")
        $scope.lastName = window.localStorage.getItem("last_name")
        // $scope.agent_name = $scope.firstName + ' ' + $scope.lastName;
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.email = window.localStorage.getItem("email")
    }
    $scope.setAgentFirsAandLastName();

        //calendar starts  
        $scope.dpOpened1 = false;
 
        $scope.open = function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.dpOpened1 = !$scope.dpOpened1;
        };
     
        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            class: 'datepicker',
            showWeeks:false
        };
     
        $scope.format = 'MMMM dd, yyyy';
     
        $scope.$watch('$scope.ticket.dateCreated', function (newDate) {
            $scope.ticket.dateCreated = moment($scope.ticket.dateCreated).format("MMMM DD, YYYY");
        }); 
    
        $scope.today = function() {
            $scope.ticket.dateCreated = new Date();
        };
        $scope.today();
    
        $scope.openDatePicker = function($event) {
            console.log("open date")
            $event.preventDefault();
            $event.stopPropagation();
            $scope.openedFrom = true;
        };
    
        $scope.dateOptionsDatePicker = {
            formatYear: 'yy',
            startingDay: 0,
            class: 'datepicker',
            showWeeks:false
        };
        //calendar ends

    $scope.convertToCamelCase = function() {
        if ($scope.ticket.title) {
            $scope.ticket.title = $scope.ticket.title
                .toLowerCase()
                .split(' ')
                .map(function(word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(' ');
        }
    };

    // $scope.fileChanged = function(element) {
    //     var file = element.files[0];
    //     if (file && file.type.match('image.*')) {
    //         var img = new Image();
    //         img.onload = function() {
    //             // Check if the image dimensions are within the required limits
    //             if (img.width > 800 || img.height > 400) {
    //                 $scope.$apply(function() {
    //                     toaster.pop('error', 'Size Error', 'Image dimensions should not exceed 800x400 pixels.', 2000);
    //                     // Clear the file input
    //                     element.value = '';
    //                     $scope.ticket.file = null;
    //                     $scope.ticket.fileDataUrl = null;
    //                 });
    //             } else {
    //                 // Process the file if the dimensions are correct
    //                 $scope.$apply(function() {
    //                     $scope.ticket.file = file;
    //                     // console.log( $scope.ticket.file, "get file here ")
    //                 });
    //                 var reader = new FileReader();
    //                 reader.onload = function(event) {
    //                     $scope.$apply(function() {
    //                         $scope.ticket.fileDataUrl = event.target.result;
    //                     });
    //                 };
    //                 reader.readAsDataURL(file);
    //             }
    //         };
    //         img.src = URL.createObjectURL(file);
    //     } else {
    //         $scope.$apply(function() {
    //             if (typeof toaster !== 'undefined') {
    //                 toaster.pop('error', 'File Type Error', 'Only image files (PNG, JPG, JPEG) are allowed.', 2000);
    //             } else {
    //                 alert('File Type Error: Only image files (PNG, JPG, JPEG) are allowed.');
    //             }
    //         });
    //     }
    // };

    $scope.fileChanged = function(element) {
        var file = element.files[0];
        if (file && file.type.match('image.*')) {
            // Process the file without checking dimensions
            $scope.$apply(function() {
                $scope.ticket.file = file;
                // Clear any existing fileDataUrl
                $scope.ticket.fileDataUrl = null;
            });
    
            var reader = new FileReader();
            reader.onload = function(event) {
                $scope.$apply(function() {
                    $scope.ticket.fileDataUrl = event.target.result;
                });
            };
            reader.readAsDataURL(file);
        } else {
            $scope.$apply(function() {
                if (typeof toaster !== 'undefined') {
                    toaster.pop('error', 'File Type Error', 'Only image files (PNG, JPG, JPEG) are allowed.', 2000);
                } else {
                    alert('File Type Error: Only image files (PNG, JPG, JPEG) are allowed.');
                }
            });
        }
    };
    
     $scope.submitSupportForm = function(){

        if(!$scope.ticket.title){
            toaster.pop('error', 'Title', 'Title field Required', 2000);
        }else if (!$scope.ticket.category) {
            toaster.pop('error', 'Category', 'Category field Required', 2000);
        }else if (!$scope.ticket.status) {
            toaster.pop('error', 'Status', 'Status field Required', 2000);
        }
        else if (!$scope.ticket.priority) {
            toaster.pop('error', 'Priority', 'Priority field Required', 2000);
        }else if (!$scope.ticket.dateCreated) {
            toaster.pop('error', 'Date', 'Date field Required', 2000);
        }
        else if(!$scope.ticket.message){
            toaster.pop('error', 'Message', 'Message field Required', 2000);
        }else if(!$scope.ticket.file){
            toaster.pop('error', 'Attachment', 'Attachment field Required', 2000);
        }
       
        else {

            var formData = new FormData();
            // formData.append('id',$scope.ticket.id);
            formData.append("agentId",$rootScope.userId);
            formData.append("callUUID","N/A");
            formData.append("phoneNumber","N/A");
            formData.append('title', $scope.ticket.title);
            formData.append('category', $scope.ticket.category);
            formData.append('status', $scope.ticket.status);
            formData.append('priority', $scope.ticket.priority);
            formData.append('message', $scope.ticket.message);
            if ($scope.ticket.file) {
                formData.append('file', $scope.ticket.file);
            }

            // console.log(formData, "get support data")
                var callbacks = {
                    success: function (data) {
                        toaster.pop('success', 'Success', 'Created Ticket Successfully', 2000);
                        $state.go('app.sales-agent.support');
                    },
                    failure: function (data) {
                        toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                        $state.go('app.sales-agent.support');
                    }
                };
                UserService.createSupport(formData,callbacks);
        }   
    }; 

}])
